<script lang="ts">
	//UI
	import MultiplePageLayout from "@hitit/hub/src/layouts/MultiplePageLayout.svelte";
	import SalesHistory from "./SalesHistory.svelte";
	import SalesCalendar from "./SalesCalendar.svelte";
	import { t } from "@hitit/hub/src/stores";
	//Utils
	import { navigate, Router, Route } from "svelte-routing";
	//Types
	//Props
	export let storeId = "";
	//Constants
	//Variables
	$: headerInfos = [
		{
			title: $t("hub.order.sales_history"),
			clickEvent: () => navigate(`/store/${storeId}/revenue/saleshistory/`),
			route: `/store/${storeId}/revenue/saleshistory/*`,
		},
		{
			title: $t("hub.order.sales_calendar"),
			clickEvent: () => navigate(`/store/${storeId}/revenue/salesCalendar`),
			route: `/store/${storeId}/revenue/salesCalendar/*`,
		},
	];
	//Functions
	//Do

</script>

<MultiplePageLayout headerInfos={headerInfos}>
	<Router>
		<Route path="/saleshistory">
			<SalesHistory storeId={storeId} />
		</Route>
		<Route path="/salesCalendar">
			<SalesCalendar storeId={storeId} />
		</Route>
	</Router>
</MultiplePageLayout>

<style lang="scss">
</style>
